import React from 'react'
import Accordion from "react-bootstrap/Accordion";

const AccordSection = () => {
    return (
        <section className="faq">
            <div className="container">
                <header className="faq__header text-center">
                    <h2 className="faq__title">Your questions about TMS Responsible Lending answered</h2>
                    <p className="faq__sub">
                        Your questions about TMS Responsible Lending answered. Click on a question below to view the answer.
                    </p>
                </header>
                <div className="faq__list">
                    <Accordion
                        // defaultActiveKey="0"
                        className="faq-item"
                    >
                        <Accordion.Item eventKey="0">
                            <Accordion.Header>
                                How much time does the claims process take?
                            </Accordion.Header>
                            <Accordion.Body>
                                Most cases take a few weeks to several months depending on the lender, the amount of information available and
                                whether additional documents are requested.
                            </Accordion.Body>
                        </Accordion.Item>
                        <Accordion.Item eventKey="1">
                            <Accordion.Header>Are there any upfront fees?</Accordion.Header>
                            <Accordion.Body>
                                No. There’s no
                                cost to check and no upfront fees. We’ll start your claim for free and if your claim is
                                successful, you would be paying our commission that starts at 36% (including VAT)
                                and going as low as 18% (including VAT) as laid out in our Terms of Business
                                Agreement
                            </Accordion.Body>
                        </Accordion.Item>
                        <Accordion.Item eventKey="2">
                            <Accordion.Header>
                                Is there a deadline to file a claim?
                            </Accordion.Header>
                            <Accordion.Body>
                                Time limits can apply and vary by situation. Start your check now and we’ll confirm the relevant timelines for your case.
                                mentioned.
                            </Accordion.Body>
                        </Accordion.Item>

                        <Accordion.Item eventKey="3">
                            <Accordion.Header>
                                What evidence is required to get started?
                            </Accordion.Header>
                            <Accordion.Body>
                                Just some basic details about you and your credit accounts. Account numbers aren’t needed to start—if we need
                                statements or other info we’ll let you know.
                            </Accordion.Body>
                        </Accordion.Item>

                        <Accordion.Item eventKey="4">
                            <Accordion.Header>
                                Can I still file a claim if I’ve had credits from more than one lender?
                            </Accordion.Header>
                            <Accordion.Body>
                                Yes. You can make claims against multiple lenders if you were affected by more than one agreement.
                            </Accordion.Body>
                        </Accordion.Item>

                        <Accordion.Item eventKey="5">
                            <Accordion.Header>
                                Will the claim impact my Credit Score?
                            </Accordion.Header>
                            <Accordion.Body>
                                The claim itself doesn’t change your score. Keep making any required payments while the claim is being assessed.
                            </Accordion.Body>
                        </Accordion.Item>
                        <Accordion.Item eventKey="6">
                            <Accordion.Header>
                                Should I expect you to contact my employer?
                            </Accordion.Header>
                            <Accordion.Body>
                                No. We only contact you and the relevant lender(s). We won’t contact your employer.
                            </Accordion.Body>
                        </Accordion.Item>
                        <Accordion.Item eventKey="111">
                            <Accordion.Header>
                                Do I need to continue paying the lender while the claim is ongoing?
                            </Accordion.Header>
                            <Accordion.Body>
                                Yes, continue with your normal payments unless you’re told otherwise by your lender. This avoids missed payment markers.
                            </Accordion.Body>
                        </Accordion.Item>

                        <Accordion.Item eventKey="7">
                            <Accordion.Header>
                                Is it possible to get a refund without using a claims company?
                            </Accordion.Header>
                            <Accordion.Body>
                                Yes, you can complain directly to the lender. Many customers choose us to prepare the case, manage deadlines and follow-ups.
                            </Accordion.Body>
                        </Accordion.Item>

                        <Accordion.Item eventKey="8">
                            <Accordion.Header>
                                Why should I use a claims company to file a claim?
                            </Accordion.Header>
                            <Accordion.Body>
                                You do not need to use a no win no fee solicitor to make a complaint to your lender. If
                                your complaint is not successful you can refer it to the Financial Ombudsman Service
                                for free. Filing yourself can be such a headache! You can save yourself from the
                                hassle by using our service.
                            </Accordion.Body>
                        </Accordion.Item>
                        <Accordion.Item eventKey="10">
                            <Accordion.Header>
                                Will you keep me updated throughout the process?
                            </Accordion.Header>
                            <Accordion.Body>
                                Absolutely. We’ll send updates at key stages by email/SMS and you can contact us any time if you need more detail.
                            </Accordion.Body>
                        </Accordion.Item>
                    </Accordion>
                </div>
            </div>
        </section>
    );
};

export default AccordSection;